import React from "react";

const TopButton = ({ setQuery }) => {
  const cities = [
    {
      id: 1,
      name: "Islamabad",
    },

    {
      id: 2,
      name: "London",
    },

    {
      id: 3,
      name: "Tokyo",
    },

    {
      id: 4,
      name: "Toronto",
    },

    {
      id: 5,
      name: "New York",
    },
  ];
  return (
    <div className="flex flex-col md:flex-row items-center justify-between my-6 border border-slate-50 rounded-lg px-2 py-1">
      {cities.map((city) => (
        <button
          key={city.id}
          className="text-white text-lg font-light hover:font-semibold "
          onClick={() => setQuery({ q: city.name })}
        >
          {city.name}
        </button>
      ))}
    </div>
  );
};

export default TopButton;
